/**
 * modal.js — Focus trap and accessible modal utilities
 * Used by cart-drawer, sidebar-nav, search-modal, and chatbot-widget.
 */

const FOCUSABLE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
  'details > summary',
].join(', ');

/**
 * Trap focus within a container element.
 * Returns a cleanup function that removes the trap.
 */
function trapFocus(container, initialFocus) {
  const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS)).filter(
    (el) => !el.closest('[hidden]') && !el.closest('[aria-hidden="true"]')
  );

  if (focusable.length === 0) return () => {};

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  const target = initialFocus && container.contains(initialFocus) ? initialFocus : first;
  target.focus();

  function handleKeydown(event) {
    if (event.key !== 'Tab') return;
    if (focusable.length === 1) {
      event.preventDefault();
      return;
    }
    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  container.addEventListener('keydown', handleKeydown);
  return () => container.removeEventListener('keydown', handleKeydown);
}

/**
 * Release focus trap and return focus to a trigger element.
 */
function releaseFocus(trigger) {
  if (trigger && typeof trigger.focus === 'function') {
    trigger.focus();
  }
}

window.SummitModal = { trapFocus, releaseFocus };
